<template>
    <div>
        <div class="sidebar open" v-if="$route.name !== 'login'">
            <div class="avatar" style="align-self: center; ">
                <img :src="userImage" class="img-fluid" style="max-height: 15rem;">
            </div>
            <div class="sidebar-header">
                <h3 class="text-center text-white mt-4">
                    <span class="text-white">{{userName}}</span>
                    <!--<router-link to="/profile">-->
                    <!--<span class="text-white">{{userName}}</span>-->
                    <!--</router-link>-->

                </h3>
                <h6 class="text-center mt-2">
                    <span class="text-white">{{role}}</span>
                    <!--<router-link to="/testpage" >-->
                    <!--<span class="text-white">مشاهده تست</span>-->
                    <!--</router-link>-->

                </h6>
            </div>
            <div class="menu-container">
                <ul class="nav flex-column accordion" id="accordion">
                    <li class="nav-item">
                        <router-link to="/home" class="nav-link">
                            <!--<i class="fa fa-pencil-square-o"></i>-->
                            <span v-if="role === 'ادمین'">پیشخوان مدیر</span>
                            <span v-else>پیشخوان</span>
                        </router-link>
                    </li>
                    <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'" >
                        <router-link to="/dailyReports" class="nav-link">
                            <span>ثبت گزارش کار</span>
                        </router-link>

                    </li>

                    <li class="nav-item mx-2" v-if="role === 'ادمین' || role === 'مدیر بازاریابی' || role=='مدیر مالی'" >
                        <router-link to="/approvalDailyReports" class="nav-link">
                            <span>تایید گزارش کار پرسنل</span>
                        </router-link>

                    </li>
                    <li class="nav-item mx-2" v-if="role === 'ادمین' || role==='مدیر مالی' ||  role ==='منشی' || role==='بازاریاب'">
                        <router-link to="/fCalendar" class="nav-link">
                            <span>تقویم مالی</span>
                        </router-link>


                    </li>
                    <li class="nav-item">
                        <a class="nav-link collapsible" data-toggle="collapse" data-target="#inquiry" role="button">
                            <span>مدیریت استعلام ها</span>
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </li>
                    <div class="collapse" id="inquiry" data-parent="#inquiry">
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/inquiris" class="nav-link">
                                <span>ثبت استعلام سامانه</span>
                            </router-link>
                        </li>
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/supplierInquiris" class="nav-link">
                                <span>استعلام قیمت از تامین کننده</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2"  v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/pickWinner" class="nav-link">
                                <span>تعیین برنده</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2"  v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/decide" class="nav-link">
                                <span>نرخ گذاری</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2"  v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/RecordInquiry" class="nav-link">
                                <span>ثبت قیمت در سامانه</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2"  v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/Clarification" class="nav-link">
                                <span>شفاف سازی</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2"  v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/Nonacceptance" class="nav-link">
                                <span>ثبت دلایل باخت و عدم  پذیرش</span>
                            </router-link>
                        </li>
                        <li class="nav-item mx-2"  v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/InquiryFollowUp" class="nav-link">
                                <span>ثبت پیگیری ها استعلام</span>
                            </router-link>
                        </li>

                    </div>

                    <li class="nav-item" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                        <a class="nav-link collapsible" data-toggle="collapse" data-target="#register" role="button">
                            <span> تعاریف اولیه</span>
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </li>
                    <div class="collapse" id="register" data-parent="#accordion"
                         v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                        <li class="nav-item mx-2" v-if="role === 'ادمین'">
                            <router-link to="/users" class="nav-link">
                                <span>کاربران/کارمندان</span>
                            </router-link>

                        </li>

                        <!--<li class="nav-item mx-2" v-if="role === 'ادمین'">-->
                        <!--<router-link to="/partners" class="nav-link">-->
                        <!--<span>شرکاء</span>-->
                        <!--</router-link>-->

                        <!--</li>-->
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/product" class="nav-link">
                                <span>کالا/خدمات</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/unit" class="nav-link">
                                <span>واحد های کالا</span>
                            </router-link>

                        </li>
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/category" class="nav-link">
                                <span>دسته های کالا</span>
                            </router-link>

                        </li>

                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/suppliers" class="nav-link">
                                <span>تامین کننده</span>
                            </router-link>


                        </li>
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/customers" class="nav-link">
                                <span>مشتریان</span>
                            </router-link>
                        </li>
                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role==='مدیر مالی'">
                            <router-link to="/TitleWorks" class="nav-link">
                                <span>سرفصل کار ها</span>
                            </router-link>
                        </li>


                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role==='مدیر مالی'">
                            <router-link to="/Causes" class="nav-link">
                                <span>سرفصل علل باخت</span>
                            </router-link>


                        </li>
                        <!--<li class="nav-item mx-2" v-if="role === 'ادمین' || role==='مدیر مالی'">-->
                            <!--<router-link to="/AssignCategoriesToUsers" class="nav-link">-->
                                <!--<span>اختصاص دسته بندی کالاها به کاربران</span>-->
                            <!--</router-link>-->
                        <!--</li>-->

                        <li class="nav-item mx-2" v-if="role === 'ادمین' || role==='مدیر مالی' || role ==='منشی' || role==='بازاریاب'">
                            <router-link to="/CategoryToSupplier" class="nav-link">
                                <span>اختصاص کالاها به تامین کنندگان</span>
                            </router-link>


                        </li>

                    </div>

                    <!--<li class="nav-item">-->
                        <!--<a class="nav-link collapsible" data-toggle="collapse" data-target="#buy" role="button">-->
                            <!--<span> مدیریت مشتری ها</span>-->
                            <!--<i class="fa fa-chevron-down"></i>-->
                        <!--</a>-->
                    <!--</li>-->
                    <!--<div class="collapse" id="buy" data-parent="#accordion">-->
                        <!--<li class="nav-item mx-2" v-if="role === 'ادمین'">-->
                            <!--<router-link to="/customers" class="nav-link">-->
                                <!--<span>تعریف مشتری</span>-->
                            <!--</router-link>-->
                        <!--</li>-->
                        <!--<li class="nav-item mx-2">-->
                            <!--<router-link to="/customerFollow" class="nav-link">-->
                                <!--<span>پیگیری مشتری</span>-->
                            <!--</router-link>-->

                        <!--</li>-->
                        <!--<li class="nav-item mx-2">-->
                            <!--<router-link to="/customerBuy" class="nav-link">-->
                                <!--<span>قراردادهای مشتری</span>-->
                            <!--</router-link>-->

                        <!--</li>-->


                    <!--</div>-->



                    <li class="nav-item mx-2">
                        <router-link to="/profile" class="nav-link">
                            <span>ویرایش پروفایل</span>
                        </router-link>

                    </li>


                </ul>
            </div>
            <!--<div>-->
                <!--<p class="">-->
                    <!--<small class="mt-3">کلیه حقوق متعلق به-->
                        <!--<a href="https://ehsanamer.ir" target="_blank"><b>شرکت داده پردازی بدیعان اندیشه می باشد</b></a>-->
                        <!--میباشد.-->
                    <!--</small>-->
                <!--</p>-->
            <!--</div>-->
        </div>
        <div class="wrapper" :class="{'wide': $route.name === 'login'}">
            <navbar v-if="$route.name !== 'login'"/>
            <transition
                    mode="out-in"
                    name="fade">
                <router-view/>
            </transition>
        </div>
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import Constants from "../_framework/Constants";

    export default {
        data() {
            return {
                name: "",
                admin: false,
                userName: "",
                userImage: "",
                mainItems: [],
                role: "",
                company_type: 0, // 1 = lab/ 2 = tarahi-nezarat / 3=ejra

            }
        },
        // beforeMount(){
        //
        // },
        mounted() {
            this.company_type = this.userId = Constants.COMPANY_TYPE;
            // new BaseService("Rezome", "/GetMainitems").getList().then(response => {
            //     this.mainItems = response.data;
            //     // console.log(this.mainItems)
            //
            // }).catch(error => {
            //     Utils.handleErrorWithNotification(error.data, this.$noty);
            // });
            this.userName = localStorage.getItem('userName');
            this.userImage = localStorage.getItem('setProfileImage');
            this.role = localStorage.getItem('role');
            EventBus.$on('userName', value => {
                this.userName = value
            });

            let theme = localStorage.getItem('theme');
            let themes = ["light", "dark"];
            if (themes.indexOf(theme) === -1) {
                require(`../assets/styles/themes/light.scss`);
            } else {
                if (theme !== null) {
                    require(`../assets/styles/themes/${theme}.scss`);
                } else {
                    require(`../assets/styles/themes/light.scss`);
                }
            }
        },
        methods: {
            gotoItem(id) {
                this.$router.push({
                    name: 'nullpage',
                    params: {
                        id: id
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .nav-item .nav-link {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .nav-item .nav-link i {
        transition: all 0.3s;
    }

    .nav-item .nav-link.collapsed i {
        transform: rotate(90deg);
    }

    .nav-item:hover .nav-link.collapsible {
        margin-right: 0;
        cursor: pointer;
    }
</style>